module.exports = __webpack_public_path__ + "img/round3.6b783957.png";